import * as React from 'react';

import {
	FormContext
} from '../shared';


function withSubmitForm<T>(eventName: string) {
	return (WrappedComponent: React.ComponentType<T>): React.ComponentType<T> => {
		const Submitter: React.SFC<any> = (props) => {
			const context = React.useContext(FormContext);
			const dynamicProps = {
				...props,
				[eventName]: (e: React.SyntheticEvent<any>) => {
					e.preventDefault();
					context.submitForm();
				}
			};

			return (
				<WrappedComponent {...dynamicProps} />
			);
		};
		Submitter.displayName = `withSubmitForm[HOC](${WrappedComponent.displayName || WrappedComponent.name})`;

		return Submitter;
	}
}

export default withSubmitForm;
